import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Arrow from "assets/icons/Arrow-down-gray-png.png";
import { Counter } from "components/Counter/Counter";
import { InputField } from "components/InputField/InputField";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { eventsSlice } from "services/api/events";
import { SolidLine } from "../Thems";

import { CheckBox } from "components/CheckBox/CheckBox";
import { getCurrency, numberFormat } from "helper/numberFormat";
import {
  Amount,
  AmountField,
  AmountSign,
  FirstDiv,
  FlexItem,
  FlexItemsContainer,
  ProductContent,
  SecondDiv,
  SelectWrapper,
  Title,
  VarientAmount,
  Wrapper,
} from "./Thems";
import { getAuthenticated } from "utils/functions";
import { Fonts, FontColors } from "theme/fontConfig";

const useStyles = makeStyles(() => ({
  formControl: {
    "& .MuiInputBase-root": {
      display: "flex",
      justifyContent: "left",
      width: "100%",
      border: 0,
      marginTop: "10px",
    },

    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px",
    },
  },
  select: {
    display: "flex",
    justifyContent: "left",
    width: "100% !importent",
    fontSize: Fonts.GeneralCaptionFont.fontSize,

    "&:focus": {
      border: 0,
    },
    "&:hover": {
      border: 0,
    },
  },
  selectIcon: {
    position: "relative",
    color: FontColors.Blue002E5C,
    fontSize: "14px",
    opacity: 0.4,
  },
  paper: {
    borderRadius: 12,
    marginTop: 8,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    "& li": {
      fontWeight: Fonts.GeneralCaptionFont.fontWeight,
      paddingTop: 8,
      paddingBottom: 8,
      fontSize: Fonts.GeneralCaptionFont.fontSize,
    },
    "& li.Mui-selected": {
      color: FontColors.Blue002E5C,
      background: "##F4F6F9",
    },
    "& li.Mui-selected:hover": {
      background: "##F4F6F9",
    },
  },
}));

export const Products = React.memo(
  ({
    productsData,
    index,
    incrementCounter,
    decrementCounter,
    formik,
    ticketUniqueId,
    totalProducts,
    handleTotalForPay,
  }) => {
    const isAuthenticated = getAuthenticated();
    const isAuth =
      localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;

    const { varients, selectedValue } = useSelector((state) => state?.Events);
    const [newData, setNewData] = useState([]);
    const [amountErrors, setAmountErrors] = useState({});
    const [editingAmount, setEditingAmount] = useState({});
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
    useEffect(() => {
      const handler = () => setIsDesktop(window.innerWidth > 768);
      window.addEventListener("resize", handler);
      return () => window.removeEventListener("resize", handler);
    }, []);

    const preventMinus = (e, value) => {
      if (
        e.code === "Minus" ||
        e.code === "Equal" ||
        e.code === "KeyE" ||
        e.code === "NumpadAdd"
      ) {
        e.preventDefault();
      }
    };

    const sortedProductIndexes = useMemo(() => {
      if (!productsData) return [];
      return productsData
        .map((p, i) => ({ index: i, type: p.type, isRequired: p.isRequired }))
        .sort((a, b) => {
          const getPriority = (p) => {
            if (p.type === "onRegistration") return 1;
            if (p.isRequired) return 2;
            return 3;
          };
          return getPriority(a) - getPriority(b);
        })
        .map((item) => item.index);
    }, [productsData]);

    const dispatch = useDispatch();
    const classes = useStyles();

    const currency = getCurrency();
    const totalPay = handleTotalForPay();

    const menuProps = {
      classes: {
        list: classes.list,
        paper: classes.paper,
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center",
      },
      getContentAnchorEl: null,
    };

    const handleSelect = (
      e,
      ticketIndex,
      productIndex,
      dropdownIndex,
      dropdownObj,
      product
    ) => {
      const varientAmount = Array.isArray(product.variantInfo)
        ? product.variantInfo.filter((val) => val.option === e.target?.value)
        : [];
      const isOpenAmountVariant = Boolean(varientAmount?.[0]?.openAmount);
      const resolvedVariantPrice = isOpenAmountVariant
        ? varientAmount?.[0]?.amount || 0
        : varientAmount?.[0]?.price || varientAmount?.[0]?.amount || 0;

      // find if the selected object include the array of selected items or not
      const selectedValueIndex = selectedValue?.map((item) => {
        if (product.variant && dropdownIndex) {
          return item[product.title]?.find(
            (item) =>
              item.indexSelected === dropdownIndex &&
              item.ticketIndex === ticketIndex
          );
        } else {
          return item[product.title]?.find(
            (item) => item.ticketIndex === ticketIndex
          );
        }
      });

      // Create array of objects for dropDown selected values, if data exist update the object
      // Update
      if (
        selectedValueIndex?.length > 0 &&
        selectedValueIndex[0] !== undefined
      ) {
        const newArray = [...selectedValue];
        const newData = newArray[0][product.title]?.map((item, index) => {
          if (!product.variant && !dropdownIndex) {
            if (item.ticketIndex === selectedValueIndex[0].ticketIndex) {
              if (e !== 0 && product.type === "openAmount") {
                return {
                  value: e,
                  ticketIndex: item.ticketIndex,
                  amount: product?.amount,
                  productId: product?._id,
                  price: item?.price,
                  type: item?.type,
                };
              } else {
                return {
                  value: e,
                  ticketIndex: item.ticketIndex,
                  amount: product?.amount,
                  productId: product?._id,
                  type: item?.type,
                };
              }
            } else {
              return { ...item };
            }
          } else {
            if (
              item.indexSelected === dropdownIndex &&
              item.ticketIndex === ticketIndex &&
              item.productId === product._id
            ) {
              return {
                value: e.target?.value,
                indexSelected: dropdownIndex,
                previousValue: item.value,
                ticketIndex: ticketIndex,
                amount: resolvedVariantPrice,
                price: resolvedVariantPrice,
                productId: product?._id,
                type: product?.type,
              };
            } else {
              return { ...item };
            }
          }
        });
        const data = [{ ...newArray[0], [product.title]: [...newData] }];
        dispatch(
          eventsSlice.actions.setSelectedValue({
            data: data,
            productIndex: productIndex,
            productTitle: product.title,
            dropdownIndex: dropdownIndex,
            type: "",
            ticketIndex: ticketIndex,
          })
        );
      }
      // Add new
      else {
        let newArray = selectedValue ? [...selectedValue] : [];
        if (newArray?.length === 0) {
          if (!product.variant && !dropdownIndex) {
            newArray.push({
              [product.title]: [
                {
                  value: e,
                  ticketIndex: ticketIndex,
                  amount: product?.amount,
                  productId: product?._id,
                  type: product?.type,
                },
              ],
            });
          } else {
            newArray.push({
              [product.title]: [
                {
                  value: e.target?.value,
                  indexSelected: dropdownIndex,
                  previousValue: "",
                  ticketIndex: ticketIndex,
                  amount: resolvedVariantPrice,
                  price: resolvedVariantPrice,
                  productId: product?._id,
                  type: product?.type,
                },
              ],
            });
          }
          dispatch(
            eventsSlice.actions.setSelectedValue({
              data: newArray,
              productIndex: productIndex,
              productTitle: product.title,
              dropdownIndex: dropdownIndex,
              type: "",
              ticketIndex: ticketIndex,
            })
          );
        } else if (!Object.keys(newArray[0]).includes(product.title)) {
          if (!product.variant && !dropdownIndex) {
            const data = [
              {
                ...newArray[0],
                [product.title]: [
                  {
                    value: e,
                    ticketIndex: ticketIndex,
                    amount: product?.amount,
                    productId: product?._id,
                    type: product?.type,
                  },
                ],
              },
            ];
            dispatch(
              eventsSlice.actions.setSelectedValue({
                data: data,
                productIndex: productIndex,
                productTitle: product.title,
                dropdownIndex: null,
                type: "",
                ticketIndex: ticketIndex,
              })
            );
          } else {
            const data = [
              {
                ...newArray[0],
                [product.title]: [
                  {
                    value: e.target?.value,
                    indexSelected: dropdownIndex,
                    previousValue: "",
                    ticketIndex: ticketIndex,
                    amount: resolvedVariantPrice,
                    price: resolvedVariantPrice,
                    productId: product?._id,
                    type: product?.type,
                  },
                ],
              },
            ];
            dispatch(
              eventsSlice.actions.setSelectedValue({
                data: data,
                productIndex: productIndex,
                productTitle: product.title,
                dropdownIndex: dropdownIndex,
                type: "",
                ticketIndex: ticketIndex,
              })
            );
          }
        } else {
          let data;
          if (!product.variant && !dropdownIndex) {
            data = [
              {
                ...newArray[0],
                [product.title]: [
                  ...newArray[0][product.title],
                  {
                    value: e,
                    ticketIndex: ticketIndex,
                    amount: product?.amount,
                    productId: product?._id,
                    type: product?.type,
                  },
                ],
              },
            ];
          } else {
            const items = newArray[0][product.title] || [];
            const exists = items.some(
              (item) =>
                item.indexSelected === dropdownIndex &&
                item.ticketIndex === ticketIndex &&
                item.productId === product._id
            );
            data = [
              {
                ...newArray[0],
                [product.title]: exists
                  ? items
                  : [
                      ...items,
                      {
                        value: e.target?.value,
                        indexSelected: dropdownIndex,
                        previousValue: "",
                        ticketIndex: ticketIndex,
                        amount: resolvedVariantPrice,
                        price: resolvedVariantPrice,
                        productId: product?._id,
                        type: product?.type,
                      },
                    ],
              },
            ];
          }
          dispatch(
            eventsSlice.actions.setSelectedValue({
              data: data,
              productIndex: productIndex,
              productTitle: product.title,
              dropdownIndex: dropdownIndex,
              type: "",
              ticketIndex: ticketIndex,
            })
          );
        }
      }

      if (product.variant) {
        formik.setFieldValue(
          `ticketsData.[${index}].[${productIndex}].dropdowns[${dropdownIndex}]`,
          {
            ...dropdownObj,
            selectedValue: e.target?.value,
            amount: resolvedVariantPrice,
            price: resolvedVariantPrice,
          }
        );
      }
    };

    useEffect(() => {
      const newArr = [];
      if (selectedValue !== undefined && selectedValue?.length !== 0) {
        const Data =
          selectedValue &&
          Object.keys(selectedValue[0]).map((key) => {
            const formatData = selectedValue[0][key]?.map((item) => {
              if (item.ticketIndex === ticketUniqueId) {
                if (item.hasOwnProperty("indexSelected")) {
                  const isExistObj = newArr.find((item) => item?.title === key);
                  const findProductIndex = newArr.findIndex(
                    (product) => product.title === key
                  );
                  // Detect open-amount variant: option has openAmount flag OR product limitType is "amount"
                  const variantProduct = productsData?.find((p) => p._id === item.productId);
                  // varients is keyed by index but each entry has an `id` field matching product._id
                  const variantEntry = Object.values(varients || {}).find(
                    (v) => v?.id === item.productId
                  );
                  const variantOptionInfo = variantEntry?.variantsInfo?.find(
                    (vi) => vi.option === item.value
                  );
                  const isOpenAmountVariant =
                    Boolean(variantOptionInfo?.openAmount) ||
                    variantProduct?.limitType === "amount";
                  const variantPrice = isOpenAmountVariant
                    ? (variantOptionInfo?.price ?? variantOptionInfo?.amount ?? variantOptionInfo?.minimumOpenAmount ?? 0)
                    : undefined;

                  if (isExistObj && isExistObj !== undefined) {
                    if (
                      newArr[findProductIndex]?.variant?.hasOwnProperty(
                        item.value
                      )
                    ) {
                      const prev = newArr[findProductIndex].variant[item.value];
                      const prevCount = typeof prev === "object" ? (prev.quantity || 0) : prev;
                      newArr[findProductIndex].variant[item.value] = isOpenAmountVariant
                        ? { quantity: prevCount + 1, price: variantPrice }
                        : { quantity: prevCount + 1 };
                    } else {
                      newArr[findProductIndex].variant[item.value] = isOpenAmountVariant
                        ? { quantity: 1, price: variantPrice }
                        : { quantity: 1 };
                    }
                  } else {
                    newArr.push({
                      id: item?.productId,
                      title: key,
                      variant: {
                        [item.value]: isOpenAmountVariant
                          ? { quantity: 1, price: variantPrice }
                          : { quantity: 1 },
                      },
                    });
                  }
                } else {
                  const productType = productsData?.filter(
                    (val) => val._id === item.productId
                  )[0];
                  if (item.value !== 0 && productType?.type === "openAmount") {
                    newArr.push({
                      id: item?.productId,
                      title: key,
                      quantity: item.value,
                      price: item?.price,
                    });
                  } else {
                    newArr.push({
                      id: item?.productId,
                      title: key,
                      quantity: item.value,
                    });
                  }
                }
              }
            });
          });
      }
      // open amount products are not in selectedValue — add from productsData counters directly
      (productsData || []).forEach((product, productIndex) => {
        if (product?.type !== "openAmount" && !product?.openAmount) return;
        const qty = product?.counter || 0;
        if (qty <= 0) return;
        const alreadyAdded = newArr.find((p) => p.id === product._id);
        if (alreadyAdded) return;
        const price = Number(formik?.values?.productsOpenAmount?.[ticketUniqueId]?.[productIndex] ?? product?.minimumOpenAmount ?? 0);
        if (price <= 0) return;
        newArr.push({ id: product._id, title: product.title, quantity: qty, price });
      });
      setNewData([...newArr]);
    }, [productsData, selectedValue, ticketUniqueId, formik?.values?.productsOpenAmount]);

    useEffect(() => {
      let newArray = newData?.filter((item) => item.quantity !== 0);
      let result = {};
      newArray.forEach((item) => {
        result[item.title] = item;
      });

      if (index !== -1) {
        formik.setFieldValue(
          `registrationForm[${index}].products`,
          newData.length === 1 && newData[0]?.quantity === 0
            ? []
            : [...newArray]
        );
      }
    }, [newData]);

    const addPriceToObjects = useCallback(
      (e, id, title) => {
        const { value } = e.target;
        let data;
        data = [
          {
            ...selectedValue[0],
            [title]: [
              { ...selectedValue[0]?.[title]?.[0], price: Number(value) },
            ],
          },
        ];
        dispatch(
          eventsSlice.actions.setSelectedValue({
            data: data,
            productIndex: id,
            productTitle: title,
            dropdownIndex: null,
            type: "",
            ticketIndex: null,
          })
        );
        const addPrice = Object.values(varients).map((el) =>
          el.id === id ? { ...el, price: Number(value) } : el
        );
        dispatch(eventsSlice.actions.setVarients(addPrice));
      },
      [formik, selectedValue, varients]
    );

    return (
      <Wrapper>
        {sortedProductIndexes?.map((productIndex) => {
          const product = productsData[productIndex];
          const minAmountProduct = product?.minimumOpenAmount || 0;

          const reserveProduct = product?.reserveProduct || 0;
          const rawCapacity = varients?.[productIndex]?.varientCapacity;
          const effectiveCapacity =
            rawCapacity === "noLimit" || rawCapacity === undefined
              ? "noLimit"
              : Math.max(0, rawCapacity - reserveProduct);
          const isAddonSoldOut =
            effectiveCapacity !== "noLimit" && effectiveCapacity <= 0;

          return (
            <>
              <ProductContent>
                <FirstDiv>
                  <FlexItemsContainer>
                    <FlexItem>
                      {product?.type === "openAmount" ? (
                        <CheckBox
                          noFont={true}
                          text={
                            <span style={{ fontSize: Fonts.GeneralLargeBodyFont.fontSize, fontWeight: Fonts.GeneralLargeBodyFont.fontWeight, textTransform: "capitalize" }}>
                              {product?.title}
                            </span>
                          }
                          checked={product?.counter > 0}
                          disabled={
                            product?.counter === 0 &&
                            effectiveCapacity !== "noLimit" &&
                            (varients?.[productIndex]?.counterValue ?? 0) >= effectiveCapacity
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              incrementCounter(
                                product?._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              formik.setFieldValue(
                                `productsOpenAmount.${ticketUniqueId}.${productIndex}`,
                                minAmountProduct
                              );
                              if (minAmountProduct) {
                                dispatch(
                                  eventsSlice.actions.setVarientPrice({
                                    productIndex,
                                    price: Number(minAmountProduct),
                                  })
                                );
                              }
                            } else {
                              decrementCounter(
                                product?._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              formik.setFieldValue(
                                `productsOpenAmount.${ticketUniqueId}.${productIndex}`,
                                0
                              );
                            }
                          }}
                        />
                      ) : product?.limitType === "checkbox" ? (
                        <CheckBox
                          noFont={true}
                          text={
                            <span style={{ fontSize: Fonts.GeneralLargeBodyFont.fontSize, fontWeight: Fonts.GeneralLargeBodyFont.fontWeight, textTransform: "capitalize" }}>
                              {product?.title}
                              {product?.isRequired && (
                                <span style={{ color: FontColors.Red }}> *</span>
                              )}
                            </span>
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              incrementCounter(
                                product._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              !product.variant &&
                                handleSelect(
                                  product?.counter + 1,
                                  ticketUniqueId,
                                  productIndex,
                                  null,
                                  null,
                                  product,
                                  product?.title
                                );
                            } else {
                              decrementCounter(
                                product._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              !product.variant &&
                                handleSelect(
                                  product?.counter - 1,
                                  ticketUniqueId,
                                  productIndex,
                                  null,
                                  null,
                                  product,
                                  product?.title
                                );
                            }
                          }}
                          checked={product?.counter > 0}
                        />
                      ) : (
                        <Title>
                          {product?.title}
                          {product?.isRequired ||
                          product?.type === "onRegistration" ? (
                            <span style={{ color: FontColors.Red }}> *</span>
                          ) : null}
                        </Title>
                      )}
                    </FlexItem>
                    <FlexItem style={product?.type === "openAmount" ? { width: isDesktop ? "200px" : "100%", marginTop: 8 } : {}}>
                      {product?.type === "openAmount" ? (
                        product?.counter > 0 && (
                          <>
                            {editingAmount[productIndex] ? (
                              <div style={{ position: "relative", width: "100%", height: 48 }}>
                                <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: Fonts.GeneralSubHeaderFont.fontSize, fontWeight: Fonts.GeneralSubHeaderFont.fontWeight, color: FontColors.Blue2555EF, pointerEvents: "none" }}>
                                  {currency}
                                </span>
                                <input
                                  autoFocus
                                  type="number"
                                  value={formik?.values?.productsOpenAmount?.[ticketUniqueId]?.[productIndex] ?? minAmountProduct}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (Number(value) > 1000000) return;
                                    formik.setFieldValue(`productsOpenAmount.${ticketUniqueId}.${productIndex}`, value);
                                    if (product.counter > 0) addPriceToObjects(e, product._id, product.title);
                                    if (Number(value) < minAmountProduct) {
                                      setAmountErrors((prev) => ({ ...prev, [`product-${productIndex}`]: `Minimum amount is ${minAmountProduct}` }));
                                    } else {
                                      setAmountErrors((prev) => ({ ...prev, [`product-${productIndex}`]: "" }));
                                    }
                                  }}
                                  onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); preventMinus(e, e.target.value); }}
                                  onBlur={() => setEditingAmount((prev) => ({ ...prev, [productIndex]: false }))}
                                  style={{ width: "100%", height: 48, boxSizing: "border-box", border: "2px solid #2555EF", borderRadius: 12, paddingLeft: 34, paddingRight: 14, fontSize: Fonts.GeneralHeaderFont.fontSize, fontWeight: Fonts.GeneralHeaderFont.fontWeight, color: FontColors.Blue002E5C, background: "#fff", outline: "none", textAlign: "right", boxShadow: "0 2px 12px rgba(37,85,239,0.12)", WebkitAppearance: "none", appearance: "none" }}
                                />
                              </div>
                            ) : (
                              <div
                                onClick={() => setEditingAmount((prev) => ({ ...prev, [productIndex]: true }))}
                                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", borderRadius: 12, padding: "11px 14px", cursor: "pointer", boxShadow: "0 2px 8px rgba(37,85,239,0.08)" }}
                              >
                                <span style={{ fontSize: Fonts.GeneralSubHeaderFont.fontSize, fontWeight: Fonts.GeneralSubHeaderFont.fontWeight, color: FontColors.Blue002E5C }}>
                                  {currency}{Number(formik?.values?.productsOpenAmount?.[ticketUniqueId]?.[productIndex] ?? minAmountProduct).toFixed(2)}
                                </span>
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2555EF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                </svg>
                              </div>
                            )}
                            {amountErrors[`product-${productIndex}`] && (
                              <div style={{ color: FontColors.Red, fontSize: Fonts.GeneralCaptionFont.fontSize, marginTop: 4 }}>{amountErrors[`product-${productIndex}`]}</div>
                            )}
                          </>
                        )
                      ) : (
                        product?.limitType === "checkbox" && !product?.variant ? (
                          <span style={{ fontWeight: Fonts.GeneralLabelFont.fontWeight, fontSize: Fonts.GeneralLabelFont.fontSize, whiteSpace: "nowrap" }}>
                            {numberFormat({ number: product?.amount, decimal: 2, style: "currency" })}
                          </span>
                        ) : product?.limitType !== "checkbox" &&
                        product?.type !== "onRegistration" && (
                          <Counter
                            key={product._id}
                            width={"100%"}
                            product={product}
                            counter={product?.counter}
                            handleClickIncrement={() => {
                              incrementCounter(
                                product._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              !product.variant &&
                                handleSelect(
                                  product?.counter + 1,
                                  ticketUniqueId,
                                  productIndex,
                                  null,
                                  null,
                                  product,
                                  product?.title
                                );
                            }}
                            handleClickDecrement={() => {
                              if (product?.counter > 0) {
                                decrementCounter(
                                  product._id,
                                  product,
                                  product?.counter,
                                  productIndex
                                );
                                !product.variant &&
                                  handleSelect(
                                    product?.counter - 1,
                                    ticketUniqueId,
                                    productIndex,
                                    null,
                                    null,
                                    product,
                                    product?.title
                                  );
                              }
                            }}
                            disabled={
                              isAddonSoldOut ||
                              (effectiveCapacity !== "noLimit" &&
                                (effectiveCapacity <=
                                  varients?.[productIndex]?.numberOfDrops ||
                                  effectiveCapacity <=
                                    varients?.[productIndex]?.counterValue))
                            }
                          />
                        )
                      )}
                    </FlexItem>
                  </FlexItemsContainer>
                </FirstDiv>

                <SecondDiv>
                  {(product?.counter > 0 ||
                    product?.type === "onRegistration") &&
                    product?.variant && (
                      <FormControl
                        fullWidth
                        className={classes.formControl}
                      >
                        {(product?.dropdowns?.length
                          ? product.dropdowns
                          : product.type === "onRegistration"
                          ? [{}]
                          : []
                        ).map((dropdown, dropdownIndex) => {
                          const selectedVariant = varients?.[
                            productIndex
                          ]?.variantsInfo?.find(
                            (v) => v.option === dropdown?.selectedValue
                          );
                          const isVariantOpenAmount =
                            selectedVariant?.openAmount;
                          const minAmount =
                            selectedVariant?.minimumOpenAmount ||
                            product?.minAmount ||
                            0;

                          return (
                            <>
                              <SelectWrapper thereIsAmount={dropdown.amount}>
                                {isVariantOpenAmount ? (
                                  <div style={{ display: "flex", flexDirection: "column", width: "130px", flexShrink: 0, marginTop: 8 }}>
                                    {editingAmount[`${productIndex}-${dropdownIndex}`] ? (
                                      <div style={{ position: "relative", width: "100%", height: 48 }}>
                                        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: Fonts.GeneralSubHeaderFont.fontSize, fontWeight: Fonts.GeneralSubHeaderFont.fontWeight, color: FontColors.Blue2555EF, pointerEvents: "none" }}>
                                          {currency}
                                        </span>
                                        <input
                                          autoFocus
                                          type="number"
                                          value={dropdown?.price ?? (selectedVariant?.amount || 0)}
                                          onChange={(e) => {
                                            const value = Number(e.target.value);
                                            if (value > 1000000) return;
                                            formik.setFieldValue(`ticketsData.[${index}].[${productIndex}].dropdowns[${dropdownIndex}].price`, value);
                                            if (value < minAmount) {
                                              setAmountErrors((prev) => ({ ...prev, [`${productIndex}-${dropdownIndex}`]: `Minimum amount is ${minAmount}` }));
                                            } else {
                                              setAmountErrors((prev) => ({ ...prev, [`${productIndex}-${dropdownIndex}`]: "" }));
                                            }
                                            const updatedVariants = {
                                              ...varients,
                                              [productIndex]: {
                                                ...varients?.[productIndex],
                                                variantsInfo: varients?.[productIndex]?.variantsInfo?.map((v) =>
                                                  v.option === dropdown?.selectedValue ? { ...v, price: value, amount: value } : v
                                                ),
                                              },
                                            };
                                            dispatch(eventsSlice.actions.setVarients(updatedVariants));
                                          }}
                                          onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); preventMinus(e, e.target.value); }}
                                          onBlur={(e) => {
                                            setEditingAmount((prev) => ({ ...prev, [`${productIndex}-${dropdownIndex}`]: false }));
                                          }}
                                          style={{ width: "100%", height: 48, boxSizing: "border-box", border: "2px solid #2555EF", borderRadius: 12, paddingLeft: 34, paddingRight: 14, fontSize: Fonts.GeneralSubHeaderFont.fontSize, fontWeight: Fonts.GeneralSubHeaderFont.fontWeight, color: FontColors.Blue002E5C, background: "#fff", outline: "none", textAlign: "right", boxShadow: "0 2px 12px rgba(37,85,239,0.12)", WebkitAppearance: "none", appearance: "none" }}
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        onClick={() => setEditingAmount((prev) => ({ ...prev, [`${productIndex}-${dropdownIndex}`]: true }))}
                                        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", borderRadius: 12, padding: "11px 14px", cursor: "pointer", boxShadow: "0 2px 8px rgba(37,85,239,0.08)" }}
                                      >
                                        <span style={{ fontSize: Fonts.GeneralSmallHeaderFont.fontSize, fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight, color: FontColors.Blue002E5C }}>
                                          {currency}{Number(dropdown?.price ?? (selectedVariant?.amount || 0)).toFixed(2)}
                                        </span>
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2555EF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                        </svg>
                                      </div>
                                    )}
                                    {amountErrors[`${productIndex}-${dropdownIndex}`] && (
                                      <div style={{ color: FontColors.Red, fontSize: Fonts.GeneralCaptionFont.fontSize, marginTop: 4 }}>{amountErrors[`${productIndex}-${dropdownIndex}`]}</div>
                                    )}
                                  </div>
                                ) : (
                                  <VarientAmount>
                                    {dropdown.amount
                                      ? `${numberFormat({
                                          number: dropdown.amount,
                                          decimal: 2,
                                          style: "currency",
                                        })}`
                                      : ""}
                                  </VarientAmount>
                                )}
                                <Select
                                  sx={{
                                    maxWidth: {
                                      xs: "100%",
                                      md: "300px",
                                      lg: "300px",
                                    },
                                    backgroundColor: "#fff",
                                    borderRadius: "6px",
                                  }}
                                  displayEmpty
                                  onChange={(e) => {
                                    handleSelect(
                                      e,
                                      ticketUniqueId,
                                      productIndex,
                                      dropdownIndex,
                                      dropdown,
                                      product,
                                      product?.title
                                    );
                                  }}
                                  value={dropdown?.selectedValue}
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  IconComponent={() => (
                                    <img
                                      src={Arrow}
                                      alt="Custom Arrow"
                                      style={{
                                        width: "12px",
                                        height: "6.4px",
                                        marginRight: 20,
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  )}
                                  MenuProps={menuProps}
                                  classes={{
                                    select: classes.select,
                                    icon: classes.selectIcon,
                                  }}
                                >
                                  <MenuItem disabled value="">
                                    <em>Select</em>
                                  </MenuItem>
                                  {varients?.[productIndex]?.variantsInfo?.map(
                                    (option, index) => (
                                      <MenuItem
                                        key={index}
                                        value={option?.option}
                                        disabled={
                                          (product?.type !== "onRegistration" &&
                                            !option?.infiniteQuantity &&
                                            (option?.quantity - (option?.reserveProduct || 0) <= 0 ||
                                              option?.counterValue >=
                                                option?.quantity - (option?.reserveProduct || 0))) ||
                                          (option?.forMemberOnly && !isAuth) ||
                                          (option?.openAmount && option?.counterValue >= 1)
                                        }
                                        className="d-flex align-items-center justify-content-between"
                                        style={{
                                          flexDirection: "row",
                                          padding: "10px",
                                        }}
                                      >
                                        <div
                                          className="d-inline-flex"
                                          style={{ gap: "5px" }}
                                        >
                                          <span>{option?.option}</span>
                                          {option?.forMemberOnly && !isAuth && (
                                            <span>(Members Only)</span>
                                          )}
                                        </div>
                                        <span style={{ marginLeft: "5px" }}>
                                          {option?.openAmount
                                            ? option?.minimumOpenAmount
                                              ? `(Min.: ${numberFormat({ number: option.minimumOpenAmount, decimal: 2, style: "currency" })})`
                                              : "Open Amount"
                                            : numberFormat({
                                                number: option?.amount,
                                                decimal: 2,
                                                style: "currency",
                                              })}
                                        </span>
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                              </SelectWrapper>
                              {dropdownIndex !==
                                product.dropdowns.length - 1 && (
                                <hr
                                  style={{
                                    border: "none",
                                    borderTop: "1px solid #E5E7EB",
                                    margin: "12px 0",
                                  }}
                                />
                              )}
                            </>
                          );
                        })}
                      </FormControl>
                    )}

                  <Amount>
                    {product.type !== "openAmount" && product?.limitType !== "checkbox" && (
                      <div
                        style={{
                          marginRight:
                            !product?.variant && window.innerWidth > 767
                              ? "54px"
                              : 0,
                        }}
                      >
                        {!product?.variant &&
                          `${numberFormat({
                            number: product?.amount,
                            decimal: 2,
                            style: "currency",
                          })}`}
                      </div>
                    )}
                  </Amount>
                </SecondDiv>
              </ProductContent>
              <SolidLine />
            </>
          );
        })}
      </Wrapper>
    );
  }
);
